import { useState } from "react";

interface AIQuestion {
  q: string;
  a: string;
}

interface SectionAIBlockProps {
  questions: AIQuestion[];
  title?: string;
}

export default function SectionAIBlock({
  questions,
  title = "Common Questions Answered",
}: SectionAIBlockProps) {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section className="bg-[#F8F7F4] py-24">
      <div className="max-w-4xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-14">
          <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#0A1628]/6 border border-[#0A1628]/10 mb-5">
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-sparkling-2-line text-[#C9A961] text-sm" />
            </span>
            <span className="text-[11px] tracking-[0.18em] text-[#0A1628]/60 uppercase font-inter font-medium">
              AI &amp; Voice Search Optimized
            </span>
          </span>
          <h2 className="text-4xl lg:text-5xl font-playfair font-bold text-[#0A1628]">
            {title}
          </h2>
        </div>

        <div className="flex flex-col gap-3">
          {questions.map((item, i) => (
            <div
              key={i}
              className={`rounded-xl border overflow-hidden transition-all duration-300 ${
                open === i
                  ? "border-[#C9A961]/50 bg-white"
                  : "border-slate-200 bg-white hover:border-slate-300"
              }`}
            >
              <button
                className="w-full flex items-center justify-between px-7 py-5 text-left cursor-pointer"
                onClick={() => setOpen(open === i ? null : i)}
              >
                <span className="font-playfair font-semibold text-[#0A1628] text-lg pr-4 leading-snug">
                  {item.q}
                </span>
                <span
                  className={`w-8 h-8 flex items-center justify-center rounded-full flex-shrink-0 transition-all duration-300 ${
                    open === i
                      ? "bg-[#C9A961] border-[#C9A961]"
                      : "border border-slate-200 bg-transparent"
                  }`}
                >
                  <i
                    className={`text-sm transition-transform duration-300 ${
                      open === i
                        ? "ri-subtract-line text-[#0A1628]"
                        : "ri-add-line text-[#C9A961]"
                    }`}
                  />
                </span>
              </button>
              {open === i && (
                <div className="px-7 pb-6 border-t-2 border-[#C9A961]">
                  <p className="text-slate-600 font-inter text-base leading-relaxed pt-5">
                    {item.a}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
